export default {
	state: {
		listaChaves: {}
	},
	getters: {
		"listaChaves": state => state.listaChaves
	},
	mutations: {
		setListaChaves(state, payload) {
			state.listaChaves = payload
		}
	},
	actions: {
		atualizarEstadoListaChaves({ commit }, payload) {
			commit('setListaChaves', payload)
		}
	}
};